// Auto-generated by extract-icons.ts — DO NOT EDIT
import { GenIcon } from "react-icons/lib";

export function LuCodeXml (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"m18 16 4-4-4-4"},"child":[]},{"tag":"path","attr":{"d":"m6 8-4 4 4 4"},"child":[]},{"tag":"path","attr":{"d":"m14.5 4-5 16"},"child":[]}]})(props);
};
